/* eslint-disable react/require-default-props */
import { Check } from '@styled-icons/boxicons-regular';
import classNames from 'classnames';
import React, { ReactElement } from 'react';
import styles from './Options.module.css';

function CheckboxItem({
  title, selected, className, onClick, checkboxSize = 18,
}:
{
  title: string | ReactElement,
  className: string,
  selected: boolean,
  onClick?: any,
  checkboxSize?: number,
}) {
  return (
    <div
      className="is-flex is-flex-direction-row is-align-items-center is-justify-content-flex-start"
      onClick={onClick || (() => null)}
      role="none"
    >
      <div
        className={classNames(
          checkboxSize < 15 ? styles.checkboxSquareSmall : styles.checkboxSquare,
          {
            [styles.checkboxChecked]: selected,
          },
        )}
      >
        <Check
          size={checkboxSize}
          className={classNames(styles.checkboxCheckIcon, {
            [styles.checkboxCheckIconSelected]: selected,
          })}
        />
      </div>
      <div className={className}>{title}</div>
    </div>
  );
}
export default CheckboxItem;
